import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  SalesOrder,
  ListSalesOrdersInput,
  ListSalesOrdersResponse,
  GetSalesOrderResponse,
} from '@erp/rpc';

export function useSalesOrdersList(filters: ListSalesOrdersInput = {}) {
  const query = useQuery(
    orpc.accountsReceivable.salesOrders.list.queryOptions({ input: filters }),
  );

  const salesOrders = query.data?.salesOrders ?? [];
  const pagination = query.data?.pagination;

  return {
    ...query,
    salesOrders,
    pagination,
  } satisfies typeof query & {
    data?: ListSalesOrdersResponse;
    salesOrders: SalesOrder[];
    pagination: ListSalesOrdersResponse['pagination'] | undefined;
  };
}

export function useSalesOrder(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.accountsReceivable.salesOrders.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
    staleTime: 30_000,
  });

  return {
    ...query,
    salesOrder: query.data?.salesOrder ?? null,
    lineItems: query.data?.lineItems ?? [],
  } satisfies typeof query & {
    data?: GetSalesOrderResponse;
    salesOrder: GetSalesOrderResponse['salesOrder'] | null;
    lineItems: GetSalesOrderResponse['lineItems'];
  };
}
